import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'repay-ment';

export const state = {
    orgId: UserPersistence.getOrgId(),
    isShow: true,
    repayMentDetails: '',
    repayMentId: '',
    abId: '',
    accountInfo: {},
    routerUrl: '',
    isView: false,
    disable: false,
    buttonType: '',
    params: null,
    billCode: ''
}
export const mutations = {
    setRepayMentDetails(state, data) {
        state.repayMentDetails = data
    },
    setRepayMentIsShow(state, flag) {
        state.isShow = flag
    },
    setOrgId(state, id) {
        state.orgId = id
    },
    setRepayMentId(state, data) {
        state.repayMentId = data.id
        state.abId = data.abId
    },

    setAccountInfo(state, data) {
        state.accountInfo = data
    },
    setRepayMentRouterUrl(state, url) {
        state.routerUrl = url
    },
    setRepayMentIsView(state, flag) {
        state.isView = flag
    },
    setRepayMentDisable(state, flag) {
        state.disable = flag
    },
    setButtonType(state, type) {
        state.buttonType = type
    },

    setParams(state, data) {
        state.params = data
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/repay-ment/index.js